import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import AuthContext from './AuthContext';
import { fetchProfile } from '../api';

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const { authTokens } = useContext(AuthContext);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refreshProfile = useCallback(async () => {
    if (!authTokens?.access) {
      setProfile(null);
      setLoading(false);
      return null;
    }

    setLoading(true);
    setError(null);
    try {
      const data = await fetchProfile(authTokens.access);
      setProfile(data);
      return data;
    } catch (requestError) {
      setError(requestError.message);
      setProfile(null);
      throw requestError;
    } finally {
      setLoading(false);
    }
  }, [authTokens?.access]);

  useEffect(() => {
    refreshProfile().catch(() => undefined);
  }, [refreshProfile]);

  return (
    <ProfileContext.Provider value={{ profile, setProfile, loading, error, refreshProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};

export default ProfileContext;
